import * as Styled from './Media.styled';
import Text from '../../../Text/Text';
import Box from '../../../Box/Box';
import Icon from '../../../Icon/Icon';
import Spinner from '../../../Spinner/Spinner';
import Thumbnail from '../../../Thumbnail/Thumbnail';
import LinkButton from '../../../Button/LinkButton/LinkButton';
import { MediaProps } from './Media.typed';

const Media = (props: MediaProps) => {
  const { media, onClickDiscard, children } = props;

  return (
    <Styled.ThumbnailWrapper data-testid="media-upload">
      <Thumbnail
        data-testid={`media-${media.serverId}`}
        presentation={true}
        image={media.url}
        elevated={true}
      >
        {media.state === 'uploading' && (
          <Styled.Overlay>
            <Box position="absolute" top="50%" left="50%" center={true}>
              <Spinner />
              {media.progress !== 0 && <Text size="s">{media.progress}%</Text>}
            </Box>
          </Styled.Overlay>
        )}
        {media.state === 'error' && (
          <Styled.Overlay>
            <>
              <Box
                position="absolute"
                top="50%"
                left="50%"
                style={{ width: '90%' }}
                center={true}
              >
                <span style={{ color: '#CC2324' }}>
                  <Icon name="AlertCircleOutline" size="m" />
                </span>
                {!!media.errorMessage && (
                  <Text weight="bold" size="s" color="#CC2324">
                    {media.errorMessage}
                  </Text>
                )}
              </Box>
              <Box position="absolute" bottom="12px" left="50%" centerX={true}>
                <LinkButton
                  intent="secondary"
                  onClick={() => onClickDiscard(media.id)}
                >
                  Discard
                </LinkButton>
              </Box>
            </>
          </Styled.Overlay>
        )}
        {media.state === 'uploaded' && <Styled.Body>{children}</Styled.Body>}
      </Thumbnail>
    </Styled.ThumbnailWrapper>
  );
};

export { Media };
